export const checkForRestrictedContent = (content: string) => {
  if (containsPhone(content) || containsEmail(content)) {
    return true;
  }
  return false;
};

export const containsPhone = (content: string) => {
  const re = /[-.)( ]*([0-9]{3})[-.)( ]*([0-9]{3})[-.)( ]*([0-9]{4})/;
  return re.test(content);
};

/**
 * Replaces phone in input with #
 *
 * @param content
 */
export const checkPhone = (input: string) => {
  if (containsPhone(input)) {
    input = input.replace(/\d{3,}/g, '###');
  }
  return input;
};

export const isEmail = (word: string) => {
  const re =
    /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;
  return re.test(word);
};

export const containsEmail = (content: string) => {
  let contains = false;
  content.split(' ').forEach(function (word: string) {
    if (isEmail(word)) {
      contains = true;
    }
  });
  return contains;
};

/**
 * Replaces email in input with #
 *
 * @param input
 */
export const checkEmail = (input: string) => {
  if (isEmail(input)) {
    return [...input].map(() => '#').join('');
  }
  return input;
};

export const getSensoredContent = (content: string) => {
  const parts = content.split(' ').map((part: string) => {
    part = checkPhone(part);
    part = checkEmail(part);
    return part;
  });
  return parts.join(' ');
};
